import React from "react";
import { useNavigate } from "react-router-dom";
import styles from '../../styles/redeem/redeemForm.module.css';
import SfxMainAudio from "../AutoPlayAudio/SfxMainAudio";
import { useEffect } from 'react';
import formImg from "../../images/v1/redeem/form_bg.png";
import { useTranslation } from "react-i18next";
function ThankYou() {
    let navigate = useNavigate();
    const navigateTo = () => navigate("/home")
    useEffect(() => {
        document.title = "Thank You | BingeBit";
    }, [])
    const {t} = useTranslation();

    return (
        <>
            <SfxMainAudio />
            <img className={styles.formImg} src={formImg} alt="..." />
            <main style={{ height: "80vh", display: "flex", "justifyContent": "center", alignItems: 'center' }}>
                <section>
                    <div className="mt-4" id="redeem-form-submit">
                        <p className="text-black text-center text-black fs-24">{t('thank_you')} </p>
                        <div className="text-center" style={{ padding: '1em' }}>
                            <p className="text-black text-center outfitRegular fs-20 mt-15 line-height-12">{t('check_inbox')}</p> <br />
                            <p className="text-black text-center outfitRegular fs-20 line-height-12">{t('working_days')}</p> <br />
                            <p className="text-black text-center outfitRegular fs-20 line-height-12">{t('happy_gaming')}</p>
                            <button className={styles.redeembtn} onClick={navigateTo}>{t('title_home')}</button>
                        </div>
                    </div>
                </section>
            </main>
        </>
    )
}

export default React.memo(ThankYou);